import React from 'react';
import { Section } from '../Section';
import { SectionTitle, SectionSubtitle, Sentence } from '../Typography';
import { useMediaQueries } from '../../utils/MediaQueries';
import { mediaQueries } from '../../style/breakpoints';
import { AnchorButton } from '../Button';
import { Price, NextSessionDate, NextSessionContainer } from './elements';

/**
 * @type React.FunctionComponent<{ withoutCenteredContent?: boolean}>
 */

const NextSessions = ({ withoutCenteredContent, nextSession, sessionPrice, isSessionName }) => {
  const mqs = useMediaQueries();
  return (
    <Section
      theme="primary"
      withoutCenteredContent={withoutCenteredContent}
      css={{
        [mediaQueries.phoneOnly]: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        [mediaQueries.tabletLandscapeUp]: {
          paddingRight: 85,
        },
      }}
    >
      <NextSessionContainer>
        {mqs.tabletLandscapeUp ? (
          <SectionTitle
            css={{
              [`@media only screen and (width: 1024px)`]: { fontSize: 44 },
              [mediaQueries.phoneOnly]: {
                justifyContent: 'center',
                textAlign: 'center',
              },
            }}
          >
            {nextSession.length > 1 ? `Prochaines sessions :${' '}` : `Prochaine session :${' '}`}
          </SectionTitle>
        ) : (
          <SectionTitle
            css={{
              [mediaQueries.phoneOnly]: {
                justifyContent: 'center',
                textAlign: 'center',
              },
            }}
          >
            {nextSession.length > 1 ? `Prochaines sessions :${' '}` : `Prochaine session :${' '}`}
          </SectionTitle>
        )}

        <NextSessionDate>
          {isSessionName && nextSession && nextSession.length > 1 ? (
            <div>
              {nextSession[0]} <br />
              {nextSession[1]}
            </div>
          ) : isSessionName ? (
            nextSession
          ) : null}
        </NextSessionDate>

        {sessionPrice[0] !== undefined ? (
          <div css={{ padding: '32px 0px' }}>
            <Price>
              <SectionSubtitle>
                {sessionPrice.length > 1 ? sessionPrice[0] : sessionPrice} €
              </SectionSubtitle>
              <Sentence css={{ fontSize: 14, paddingLeft: 5, paddingBottom: 5 }}> HT</Sentence>
            </Price>
            <Sentence>
              {isSessionName === 'typescript' ? '3' : '5'} jours (
              {isSessionName === 'typescript' ? '21' : '35'} heures) - Paris
            </Sentence>
          </div>
        ) : (
          <div css={{ paddingBottom: '64px', marginBottom: '58px' }}>
            <Sentence>
              {isSessionName === 'typescript' ? '3' : '5'} jours (
              {isSessionName === 'typescript' ? '21' : '35'} heures) - Paris
            </Sentence>
          </div>
        )}

        <AnchorButton to="/devis/">Nous contacter</AnchorButton>
      </NextSessionContainer>
    </Section>
  );
};

export default NextSessions;
